export const clearEmTags = (value: string) => {
  return value.replace(/<\/?em>/g, '');
};
export const clearWhiteSpace = (text: string) => {
  return text.replace(/\s+/g, ' ').trim();
};
